import { render, staticRenderFns } from "./contact-service.vue?vue&type=template&id=9551f4c6&scoped=true"
import script from "./contact-service.vue?vue&type=script&lang=js"
export * from "./contact-service.vue?vue&type=script&lang=js"
import style0 from "./contact-service.vue?vue&type=style&index=0&id=9551f4c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9551f4c6",
  null
  
)

export default component.exports